import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  fetchActiveForms,
  fetchAllowedUsersToForm,
  fetchArchivedForms,
  fetchFilledForms,
  fetchFormsScheduledForFuture,
  fetchPlannedForms,
  fetchSavedFormData,
  removeDraft,
  removeForm,
} from "../../redux/actions";
import { Redirect } from "react-router-dom";
import SingleForm from "./single-form";
import Can from "../../components/can";
import PageTitle from "../../components/page-title";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import SingleScheduledForm from "./scheduled-form";
import groupBy from "lodash/groupBy";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Loader from "../../components/loader";
import { FilledFormData } from "../../components/filled-form-data";
import format from "date-fns/format";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { getLoginRedirectPath } from "../../redux/common";

const useStyles = makeStyles((theme) => ({
  // table: {
  //   minWidth: 340,
  // },
  fontSize: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body1.fontSize,
  },
  tableCell: {
    fontSize: theme.typography.body1.fontSize,
    paddingRight: 2,
    paddingLeft: 3,
    rgiht: 0,
    border: theme.palette.primary.main === "#fff200" && "1px solid #fff200",
  },
  lastTableCell: {
    fontSize: theme.typography.body1.fontSize,
    paddingRight: 0,
    paddingLeft: 3,
    rgiht: 0,
    border: theme.palette.primary.main === "#fff200" && "1px solid #fff200",
  },
  root: {
    "& > *": {
      borderBottom: "unset",
      border: theme.palette.primary.main === "#fff200" && "1px solid #fff200",
    },
  },
  rootGrid: {
    display: "flex",
    // marginLeft: theme.spacing(0.1),
    overflowX: "auto",
    overflowY: "hidden",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  button: {
    border: theme.palette.primary.main === "#fff200" && "1px solid #fff200",
    backgroundColor: theme.palette.primary.main === "#fff200" && "black",
    color: theme.palette.primary.main === "#fff200" && "#fff200",
  },
  smallScreenTableCell: {
    [theme.breakpoints.down("xs")]: {
      wordWrap: "break-word",
      maxWidth: "65px",
    },
  },
}));
const Page = ({
  history,
  loggedIn,
  filledForms,
  fetchAllowedUsersToForm,
  allowedUsersToForm,
}) => {
  const globalTheme = useSelector((s) => s.globalTheme);
  const archivedForms = useSelector((s) => s.archivedForms) || null;
  const activeForms = useSelector((s) => s.activeForms) || null;
  const plannedForms = useSelector((s) => s.plannedForms) || null;
  const scheduledForFutureForms =
    useSelector((s) => s.scheduledForFutureForms) || null;
  const [groupedArchivedForms, setGroupedArchivedForms] = useState([]);
  const [groupedSavedForms, setGroupedSavedForms] = useState([]);
  const [open, setOpen] = useState(false);
  const [usersAllowedToForm, setUsersAllowedToForm] = useState([]);
  const [fetchingFormList, setFetchingFormList] = useState(false);
  const [formsFechtedDone, setFormsFechtedDone] = useState(false);
  const myId = useSelector((s) => s.my.id);
  const savedForms = useSelector((s) => s.savedForms) || null;
  const dispatch = useDispatch();
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  useEffect(() => {
    async function fetchFormdData() {
      if (loggedIn) {
        await dispatch(fetchActiveForms());
        await dispatch(fetchPlannedForms());
        await dispatch(fetchArchivedForms());
        await dispatch(fetchSavedFormData());
        await dispatch(fetchFormsScheduledForFuture());
      }
    }

    fetchFormdData();
  }, [loggedIn]);

  useEffect(() => {
    setFormsFechtedDone(
      activeForms &&
        plannedForms &&
        archivedForms &&
        scheduledForFutureForms &&
        savedForms
        ? true
        : false
    );
  }, [
    archivedForms,
    activeForms,
    plannedForms,
    savedForms,
    scheduledForFutureForms,
  ]);

  useEffect(() => {
    if (
      usersAllowedToForm?.length === plannedForms?.length ||
      !plannedForms ||
      !usersAllowedToForm
    ) {
      setFetchingFormList(false);
    }
  }, [usersAllowedToForm, plannedForms]);

  useEffect(() => {
    if (plannedForms) {
      plannedForms.map((pForm) => {
        fetchAllowedUsersToForm(pForm.form.id).then(function (result) {
          setUsersAllowedToForm((oldArray) => [
            ...oldArray,
            { id: pForm.form.id, users: result },
          ]);
        });
      });
    }
  }, [plannedForms]);

  useEffect(() => {
    if (archivedForms) {
      var grouped = groupBy(archivedForms, function (archivedForm) {
        return archivedForm.bag.id;
      });

      for (var propt in grouped) {
        grouped[propt].sort(function (a, b) {
          return b.edition - a.edition;
        });
      }

      grouped = Object.entries(grouped).map((group) => group[1]);
      setGroupedArchivedForms(grouped);
    }
  }, [archivedForms]);

  const fill = (id) => {
    history.push(`/formdata/add/${id}`);
  };
  const remove = (id) => {
    removeForm(id);
  };

  const classes = useStyles();

  function UngrouppedRow({ form, id, createdAt }) {
    return (
      <TableRow className={classes.root}>
        <TableCell
          numeric="true"
          className={classes.tableCell}
          component="th"
          scope="row"
        >
          {form.name}
        </TableCell>
        <TableCell
          numeric="true"
          className={classes.tableCell}
          component="th"
          scope="row"
        >
          {format(new Date(createdAt), "yyyy-MM-dd HH:mm")}
        </TableCell>
        <TableCell numeric="true" className={classes.tableCell}>
          {/* <button
            onClick={() => {
              history.push(`/formdata/edit/${form.id}/${id}`);
            }}
            className="button"
          >
            Edytuj
          </button> */}
          <Button
            variant="outlined"
            className={`${classes.button} ${classes.fontSize}`}
            onClick={() => {
              history.push(`/formdata/edit/${form.id}/${id}`);
            }}
            // className="button"
          >
            Edytuj
          </Button>

          {/* <button
            onClick={async () => {
              await dispatch(removeDraft(id));
              await fetchPlannedForms();
            }}
            className="button"
          >
            Usuń
          </button> */}
          <Button
            variant="outlined"
            className={`${classes.button} ${classes.fontSize}`}
            onClick={async () => {
              await dispatch(removeDraft(id));
              await fetchPlannedForms();
            }}
            // className="button"
          >
            Usuń
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  function Row(props) {
    const { form } = props;
    const [open, setOpen] = React.useState(false);

    const classes = useStyles();

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell numeric="true" className={classes.tableCell}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <Tooltip title="Zwiń listę historycznych wersji formularza.">
                  <KeyboardArrowUpIcon
                    style={{
                      fill: globalTheme === "high-contrast" && "#fff200",
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Rozwiń listę historycznych wersji formularza.">
                  <KeyboardArrowDownIcon
                    style={{
                      fill: globalTheme === "high-contrast" && "#fff200",
                    }}
                  />
                </Tooltip>
              )}
            </IconButton>
          </TableCell>
          <TableCell
            numeric="true"
            className={classes.tableCell}
            component="th"
            scope="row"
          >
            {form[0].name}
          </TableCell>
          <TableCell numeric="true" className={classes.tableCell}>
            <Tooltip title="Wypełnione formularze. Kliknij by obejrzeć.">
              <Button
                variant="outlined"
                className={`${classes.button} ${classes.fontSize}`}
                onClick={() => {
                  history.push(`/formdata/all/${form[0].id}`);
                }}
                // className="button"
              >
                {form[0].filledFormCount || 0}
              </Button>
            </Tooltip>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            className={classes.tableCell}
            style={{
              paddingBottom: 0,
              paddingTop: 0,
            }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  Historyczne wersje formularza
                </Typography>
                <Table size="small" aria-label="purchases">
                  {form.length > 1 && (
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableCell}>
                          Nazwa
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          Historia wypełnień
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {form.length > 1 ? (
                      form
                        .filter((form, index) => index !== 0)
                        .map((f, index) => (
                          <TableRow
                            key={index}
                            // className={classes.tableCell}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tableCell}
                            >
                              {`${f.name} (v.${f.edition})`}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              <Tooltip title="Wypełnione formularze. Kliknij by obejrzeć.">
                                {/* <button
                                  onClick={() => {
                                    history.push(`/formdata/all/${f.id}`);
                                  }}
                                  className="button"
                                >
                                  {f.filledFormCount || 0}
                                </button> */}
                                <Button
                                  variant="outlined"
                                  className={`${classes.button} ${classes.fontSize}`}
                                  onClick={() => {
                                    history.push(`/formdata/all/${f.id}`);
                                  }}
                                  // className="button"
                                >
                                  {f.filledFormCount || 0}
                                </Button>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{
                          color:
                            globalTheme === "high-contrast"
                              ? "#fff200"
                              : "grey",
                        }}
                      >
                        Brak
                      </Typography>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const page = () => (
    <div>
      {!formsFechtedDone ? (
        <Grid>
          <Box p={3}>
            <Loader loading={true} text="Pobieranie listy formularzy..." />
          </Box>
        </Grid>
      ) : (
        <div className={classes.rootGrid}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box p={1}>
                <PageTitle title="Aktywne formularze" />
              </Box>
              {!(activeForms && activeForms.length > 0) ? (
                <Box p={1}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      color:
                        globalTheme === "high-contrast" ? "#fff200" : "grey",
                    }}
                  >
                    Brak
                  </Typography>
                </Box>
              ) : (
                <Paper className={classes.rootGrid}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableCell}>
                          Nazwa formularza
                        </TableCell>
                        <TableCell numeric="true" className={classes.tableCell}>
                          Historia wypełnień
                        </TableCell>
                        <TableCell
                          numeric="true"
                          className={classes.tableCell}
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {activeForms &&
                        activeForms.map((form) => (
                          <SingleForm
                            filledFormsDisplay={false}
                            key={form.id}
                            form={form}
                            fill={fill}
                            // fetchFilledForms={fetchFilledForms}
                            filledForms={filledForms}
                            history={history}
                          />
                        ))}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            </Grid>

            <Grid item xs={12}>
              <Box p={1}>
                <PageTitle title="Zaplanowane formularze" />
              </Box>
              {!(
                (scheduledForFutureForms &&
                  scheduledForFutureForms.length > 0) ||
                (plannedForms &&
                  plannedForms.length > 0 &&
                  plannedForms.find((f) => f.form.status === "ACTIVE"))
              ) ? (
                <Box p={1}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      color:
                        globalTheme === "high-contrast" ? "#fff200" : "grey",
                    }}
                  >
                    Brak
                  </Typography>
                </Box>
              ) : (
                <Paper className={classes.rootGrid}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                        >
                          Nazwa formularza
                        </TableCell>
                        <TableCell
                          numeric="true"
                          className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                          style={{
                            maxWidth: smallScreen && "45px",
                          }}
                        >
                          Aktywny od
                        </TableCell>
                        <TableCell
                          numeric="true"
                          className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                          style={{
                            maxWidth: smallScreen && "45px",
                          }}
                        >
                          Aktywny do
                        </TableCell>
                        <TableCell
                          numeric="true"
                          className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                        >
                          Pozostały czas
                        </TableCell>
                        <TableCell
                          numeric="true"
                          className={classes.lastTableCell}
                          style={{ position: "sticky", right: 0 }}
                          style={{
                            wordWrap: "break-word",
                          }}
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <>
                        {plannedForms &&
                          plannedForms.map((form) => {
                            const formWithUsersAllowed = usersAllowedToForm.find(
                              ({ id }) => id === form.form.id
                            );
                            if (
                              formWithUsersAllowed &&
                              formWithUsersAllowed.users.length > 0
                            ) {
                              return (
                                form.form.status === "ACTIVE" &&
                                formWithUsersAllowed.users.find(
                                  ({ userId }) => userId === myId
                                ) &&
                                formWithUsersAllowed.users.find(
                                  ({ userId }) => userId === myId
                                ).selected && (
                                  <SingleScheduledForm
                                    key={form.id}
                                    scheduledForm={form}
                                    fill={(id, schedId) =>
                                      history.push({
                                        pathname: `/formdata/fill-scheduled-test/${id}/${schedId}`,
                                        state: { endDate: form.endDate },
                                      })
                                    }
                                    // fetchFilledForms={fetchFilledForms}
                                    filledForms={filledForms}
                                    history={history}
                                  />
                                )
                              );
                            }

                            return (
                              form.form.status === "ACTIVE" && (
                                <SingleScheduledForm
                                  key={form.id}
                                  scheduledForm={form}
                                  fill={(id, schedId) =>
                                    history.push({
                                      pathname: `/formdata/fill-scheduled-test/${id}/${schedId}`,
                                      state: { endDate: form.endDate },
                                    })
                                  }
                                  // fetchFilledForms={fetchFilledForms}
                                  filledForms={filledForms}
                                  history={history}
                                />
                              )
                            );
                          })}
                      </>

                      <>
                        {scheduledForFutureForms.map((formWrapper) => (
                          <TableRow>
                            <TableCell
                              className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                              component="th"
                              scope="row"
                            >
                              {formWrapper.form.name}
                            </TableCell>
                            <TableCell
                              className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                            >
                              {format(
                                new Date(formWrapper.startDate),
                                "yyyy-MM-dd HH:mm"
                              )}
                            </TableCell>
                            <TableCell
                              className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                            >
                              {format(
                                new Date(formWrapper.endDate),
                                "yyyy-MM-dd HH:mm"
                              )}
                            </TableCell>
                            <TableCell
                              className={`${classes.tableCell} ${classes.smallScreenTableCell}`}
                            ></TableCell>
                            <TableCell
                              align="right"
                              className={`${classes.lastTableCell} ${classes.smallScreenTableCell}`}
                            ></TableCell>
                          </TableRow>
                        ))}
                      </>
                    </TableBody>
                  </Table>
                </Paper>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box p={1}>
                <PageTitle title="Archiwalne formularze" />
              </Box>
              {!(groupedArchivedForms && groupedArchivedForms.length > 0) ? (
                <Box p={1}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      color:
                        globalTheme === "high-contrast" ? "#fff200" : "grey",
                    }}
                  >
                    Brak
                  </Typography>
                </Box>
              ) : groupedArchivedForms.length === 1 ? (
                <Box p={1}>
                  {" "}
                  <FilledFormData
                    formId={groupedArchivedForms[0][0].id}
                    showMissedFilter={true}
                    showMissed={true}
                  ></FilledFormData>
                </Box>
              ) : (
                <Paper className={classes.rootGrid}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableCell} />
                        <TableCell className={classes.tableCell}>
                          Nazwa formularza
                        </TableCell>
                        <TableCell numeric="true" className={classes.tableCell}>
                          Historia wypełnień
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupedArchivedForms.map(
                        (groupedArchivedForm, index) => (
                          <Row key={index} form={groupedArchivedForm} />
                        )
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box p={1}>
                <PageTitle title="Zapisane formularze - wersja robocza" />
              </Box>
              {!(savedForms?.length > 0) ? (
                <Box p={1}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      color:
                        globalTheme === "high-contrast" ? "#fff200" : "grey",
                    }}
                  >
                    Brak
                  </Typography>
                </Box>
              ) : (
                <Paper className={classes.rootGrid}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableCell}>
                          Nazwa formularza
                        </TableCell>
                        <TableCell numeric="true" className={classes.tableCell}>
                          Data utworzenia
                        </TableCell>
                        <TableCell numeric="true" className={classes.tableCell}>
                          Opcje
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savedForms.map((savedForm) => (
                        <UngrouppedRow {...savedForm} />
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );

  const redirect = () => <Redirect to={getLoginRedirectPath()} />;

  return <Can permission="activeforms-page:view" ok={page} not={redirect} />;
};

const mapStateToProps = (state) => ({
  organization: state.organization,
  loggedIn: state.loggedIn,
  filledForms: state.filledForms,
  allowedUsersToForm: state.allowedUsersToForm,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllowedUsersToForm: (formId) =>
    dispatch(fetchAllowedUsersToForm(formId)),
});

const ActiveFormsPage = connect(mapStateToProps, mapDispatchToProps)(Page);
export default ActiveFormsPage;
